import { Button, Form, Input, Modal, Select, Switch } from "antd";

import { selectFormOptionsNoFormatting } from "../../../../../utils/helper";

const CreateEditSubsectionModal = ({
  isModalOpen = false,
  isEdit = false,
  setIsModalOpen = () => {},
  initialValues = {},
  handleCreateEdit = () => {},
  educatorList = [],
  resources = []
}) => {
  const [form] = Form.useForm();
  const resourcesFormOptions = resources.map((resource) => {
    return {
      label: resource.title,
      value: resource._id
    };
  });

  return (
    <Modal
      title="Create/Edit Subsection"
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => setIsModalOpen(false)}
    >
      <Form
        form={form}
        initialValues={isEdit ? initialValues : {}}
        name="new_subsection_form"
        onFinish={handleCreateEdit}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter a name!"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[
            {
              required: true,
              message: "Please enter a description!"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="videoLink" label="Video Link">
          <Input />
        </Form.Item>
        <Form.Item
          name="lectureFeedbackSurveyLink"
          label="Feedback Link"
          rules={[
            {
              pattern: /^(https:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/,
              message: "Please paste a valid link!"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="sourceType"
          label="Source"
          rules={[
            {
              required: true,
              message: "Please select a source type!"
            }
          ]}
        >
          <Select
            options={selectFormOptionsNoFormatting(["VIMEO", "YOUTUBE", "TP_STREAMS"])}
            showSearch
            allowClear
          />
        </Form.Item>
        <Form.Item name="tpStreamsAssetId" label="TP Streams Asset ID">
          <Input />
        </Form.Item>
        <Form.Item
          name="sequenceOrder"
          label="Sequence Order"
          rules={[
            {
              required: true,
              message: "Please enter a sequence number!"
            },
            {
              required: /[\d]+/,
              message: "Number is invalid!"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="educatorId"
          label="Educator"
          rules={[
            {
              required: true,
              message: "Please select a Educator!"
            }
          ]}
        >
          <Select
            options={educatorList}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => (option?.label ?? "").includes(input)}
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
          />
        </Form.Item>
        <Form.Item name="resourceIds" label="Resources">
          <Select mode="multiple" options={resourcesFormOptions || []} showSearch allowClear />
        </Form.Item>
        <Form.Item name="hidden" label="Keep the section hidden?" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {isEdit === true ? "Update" : "Create"} Subsection
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEditSubsectionModal;
